"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @file events of waterfall chart is equal to column chart
 */
var event_1 = require("../column/event");
exports.EVENT_MAP = event_1.EVENT_MAP;
exports.onEvent = event_1.onEvent;
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/bullet/event.js
// module id = 884
// module chunks = 37